<form *ngIf="showFormControlDetail" [formGroup]="dynaFormControlForm" autocomplete="off" novalidate=""
            style="margin-bottom: 10px;">
            <div class="form-group row">
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="name">
                </div>
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="ID">
                </div>
                <div class="col-sm-5">
                    <label>Display Name : </label>
                </div>
                <div class="col-sm-7">
                    <input class="form-control form-control-sm" formControlName="displayName">
                </div>
                <div class="col-sm-12">
                    <button type="button" class="btn btn-sm btn-secondary"
                        (click)="updateFormValues(dynaFormControlForm.value,'update')">Update</button>
                </div>
            </div>
        </form>
<div class="row">
    <div class="col-md-6">
        <table  class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    Available
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="AvailableControls">
                <tr id="ai">
                    <td></td>
                </tr>
                <tr [id]="ac.InterfaceElementID" *ngFor="let ac of availableControls">
                    <td>{{ac.DisplayProperties.DisplayName}}
                        <span style="visibility:hidden" id="{{controlCode}}{{ac.InterfaceElementID}}">
                            <button class="btn btn-xs btn-secondary"
                                (click)="editDynaControlEditorItem(ac)">
                                <i id="button_DynaEdit" style="color:white"></i>
                            </button>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="col-md-6">
        <table  class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    Visible
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="VisibleControls">
                <tr id="vi">
                    <td></td>
                </tr>
                <tr [id]="vc.InterfaceElementID" *ngFor="let vc of visibleControls">
                    <td>{{vc.DisplayProperties.DisplayName}}
                        <span id="{{controlCode}}{{vc.InterfaceElementID}}">
                            <button class="btn btn-sm btn-secondary"
                                (click)="editDynaControlEditorItem(vc)">
                                <i id="button_DynaEdit" style="color:white"></i>
                            </button>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>          
    </div>
</div>

